import CurrencyTransactionRate from 'components/new/CurrencyTransactionRate';
import CurrencySaleReview from 'components/new/CurrencySaleReview';
import CurrencyTransactionSummary from 'components/new/CurrencyTransactionSummary';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { Row } from 'further-ui/components/Layout';
import { CurrencyTransactionOperation } from 'components/new/CurrencyTransactionSummary/types';
import PageSection from 'components/new/PageSection';

type Props = {
  reconciliationDetails: {
    isForeignCurrencySale: boolean;
    isBankTransfer: boolean;
    sale: {
      total: number;
      currency: CurrencyCode;
      income: number;
      costs: number;
      bankTransactionAmount?: number;
    };
    purchase: {
      total: number;
      currency: CurrencyCode;
      income: number;
      costs: number;
      bankTransactionAmount?: number;
    };
    currencyRate?: {
      sourceCurrency: CurrencyCode;
      targetCurrency: CurrencyCode;
      rate: number;
    };
    foreignCurrencyPurchaseRate: number;
    foreignCurrencySaleGain: {
      gainAmountLcy: number;
    };
  };
};

const MultiCurrencyReview: React.FC<Props> = ({ reconciliationDetails }) => {
  const {
    isForeignCurrencySale,
    isBankTransfer,
    sale,
    purchase,
    currencyRate,
    foreignCurrencyPurchaseRate,
    foreignCurrencySaleGain,
  } = reconciliationDetails;

  return (
    <PageSection
      spacing="lg"
      title="Review foreign exchange transaction"
      withoutBottomDivider
    >
      <Row fullWidth justify="space-between" spacing="lg" breakpoint="md">
        {sale && (
          <CurrencyTransactionSummary
            {...sale}
            isTransfer={isBankTransfer}
            operation={CurrencyTransactionOperation.Sale}
          />
        )}
        {currencyRate && <CurrencyTransactionRate {...currencyRate} />}
        {purchase && (
          <CurrencyTransactionSummary
            {...purchase}
            isTransfer={isBankTransfer}
            operation={CurrencyTransactionOperation.Purchase}
          />
        )}
      </Row>
      {isForeignCurrencySale && (
        <CurrencySaleReview
          rootCurrency={purchase.currency}
          saleAmount={sale.total}
          purchaseAmount={purchase.total}
          saleRate={currencyRate?.rate ?? 1}
          purchaseRate={foreignCurrencyPurchaseRate ?? 0}
          foreignCurrencyGain={foreignCurrencySaleGain.gainAmountLcy}
        />
      )}
    </PageSection>
  );
};

export default MultiCurrencyReview;
